import { c as _c } from "react-compiler-runtime";
import I18n from 'I18n';
import { useMemo } from 'react';
export default function useButtonA11yProps(t0) {
  "use memo";

  const $ = _c(10);
  const {
    i18nKey,
    onClick,
    allowTabbing: t1
  } = t0;
  const allowTabbing = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== i18nKey) {
    t2 = I18n.text(i18nKey);
    $[0] = i18nKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== allowTabbing) {
    t3 = allowTabbing ? {
      tabIndex: 0
    } : {};
    $[2] = allowTabbing;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClick) {
    t4 = e => {
      if (e.key === "Enter" || e.key === " ") {
        onClick(e);
      }
    };
    $[4] = onClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = Object.assign({
      role: "button",
      "aria-label": t2
    }, t3, {
      onKeyDown: t4
    });
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}